import { css } from 'styled-components';
import {
  DefaultBackToTopButton,
  DesktopBackToTopButton,
  RootStyledLink,
  StyledIcon,
  StyledLink,
  TextContainer,
} from '../../../../components/Breadcrumbs/styles';
import colors, { colorWithOpacity } from '../../../../helpers/colors';
import spacing from '../../../../helpers/spacing';
import { themeSpecificColors } from '../../colors';
import { fonts } from '../../fonts';
import { focusBoxShadowStyle } from '../../helpers/commonStyles';

const breadcrumbsTextStyle = css`
  ${fonts.paragraphSmall};
`;

const breadcrumbsLinkStyle = css`
  padding: ${spacing(0.25)};

  &:focus-visible {
    &:after {
      ${focusBoxShadowStyle}
      border-radius: 0;
    }
  }

  &:active {
    background-color: ${colorWithOpacity(colors.core01, 0.1)};
  }
`;

export default css`

  ${TextContainer} {
    ${breadcrumbsTextStyle}
    color: ${themeSpecificColors.neutral03_darker};
  }

  ${StyledLink} {
    ${breadcrumbsTextStyle}
    ${breadcrumbsLinkStyle}
  }

  ${RootStyledLink} {
    ${breadcrumbsTextStyle}
    ${breadcrumbsLinkStyle}
  }

  ${DesktopBackToTopButton}, ${DefaultBackToTopButton} {
    ${breadcrumbsTextStyle}
  }

  ${StyledIcon} {
    svg {
      fill: ${themeSpecificColors.core06};

      path {
        fill: ${themeSpecificColors.core06};
      }
    }
  }
`;
